import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';

// import en from './locales/en.json';
// import fr from './locales/fr.json';
// import pt from './locales/pt.json';

i18n
  .use(initReactI18next)
  .init({
    // init data
    resources: {
      es: {
        translation: es,
      },
      // fr: {
      //   translation: fr,
      // },
      // en: {
      //   translation: en,
      // },
      // pt: {
      //   translation: pt,
      // },
    },
    fallbackLng: 'es',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
